import {config} from '../config';

export default {
    getBleDisabledForDevice: () => config.data.deviceConnectionType.bleDisabled,
};
